import { RCCallout, RCButtonLink } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import React from 'react';
import URLHelpers from '../shared/url_helpers';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import { WarningIcon } from '@reverbdotcom/cadence/icons/react';
import { useHelpCenterArticleUrl } from '@reverbdotcom/commons/src/url_helpers';
import I18n from 'i18n-js';

const FIRST_ALERT = 'first_alert';
const SECOND_ALERT = 'second_alert';
const THIRD_ALERT = 'third_alert';
const HELP_CENTER_ARTICLE_ID = '41988483251483';

export interface Props {
  alertLevel: string;
}

const bannerVariant = {
  [FIRST_ALERT]: 'notice-ultralight',
  [SECOND_ALERT]: 'notice-ultralight',
  [THIRD_ALERT]: 'urgent-ultralight',
} as const;

export function NegativeBalanceBanner({
  alertLevel,
}: Props) {
  return (
    <RCCallout
      themeType="utility"
      variant={bannerVariant[alertLevel] ?? 'notice-ultralight'}
      icon={<WarningIcon />}
      title={I18n.t(`discovery.negativeBalances.${alertLevel}.headline`)}
      cta={(
        <RCButtonLink
          variant="filled"
          renderLink={c => <CoreLink to={URLHelpers.mySellingStatementsPath()}>{c}</CoreLink>}
        >
          <Translate text="discovery.negativeBalances.updateBillingCard" />
        </RCButtonLink>
      )}
    >
      <Translate tag="p" text={`discovery.negativeBalances.${alertLevel}.message`}>
        <a
          className="text-link"
          href={useHelpCenterArticleUrl(HELP_CENTER_ARTICLE_ID)}
          rel="noreferrer"
          target="_blank"
        >
          <Translate text="discovery.negativeBalances.learnMore"/>
        </a>
      </Translate>
    </RCCallout>
  );
}

export default NegativeBalanceBanner;
